import "./Home.module.css";
import HeaderNavigazione from "@/reusable_sections/Header";
import BenvenutiInStudioMess from "./sections/BenvenutiInStudioMess";
import ChiSiamo from "./sections/ChiSiamo";
import SoluzioniDiSicurezzaEIngegneria from "./sections/SoluzioniDiSicurezzaEIngegneria";
import EccellenzaESettoriOperativi from "./sections/EccellenzaESettoriOperativi";
import NewsETestimonianze from "./sections/NewsETestimonianze";
import GoogleReviews from "./sections/GoogleReviews";
import RichiediUnPreventivoTrasparente from "./sections/RichiediUnPreventivoTrasparente";
import GoogleReview from "./sections/GoogleReview";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <HeaderNavigazione />
      <BenvenutiInStudioMess />
      <ChiSiamo />
      <SoluzioniDiSicurezzaEIngegneria />
      <EccellenzaESettoriOperativi />
      <NewsETestimonianze />
      <GoogleReviews />
      <RichiediUnPreventivoTrasparente />
      <GoogleReview />
      <Footer />
    </div>;
}